import dayjs from 'dayjs';
import '../../vendors/intlTelInput/intlTelInput';
import _filter from 'lodash/filter';
import _isEqual from 'lodash/isEqual';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { deviceAndMqbeMatch } from '../../core/iberapi/mqbe_device_type_match/mqbe_device_type_match';

dayjs.extend(customParseFormat);

$(function () {
  'use strict';
  let $quote_form = $('.quote-form');

  if (!$quote_form.length) return false;

  let html = $('html');
  let language = html.attr('lang');
  let date_format = html.attr('data-date-format');
  let start_of_week = html.attr('data-start-of-week');
  let $hotel_selector = $quote_form.find('.hotel-selector');
  let $is_date = $quote_form.find('.is-date');
  let $check_in = $is_date.find('.check-in');
  let $check_out = $is_date.find('.check-out');
  let $selection_box = $('.hotel-selection');
  let $quoteFormPhone = $quote_form.find('#phone');
  let $quoteFormPhoneManual = $quote_form.find('#phone-manual-fill');
  let fastbooking_data = IB.hotels_data.check() ? IB.hotels_data.getData() : IB.hotels_data.get(function () {fastbooking_data = IB.hotels_data.getData();});
  let date_range_picker_options = {
    format:      date_format,
    startOfWeek: start_of_week,
    language:    language,
    startDate:   new dayjs().format(date_format),
    autoClose:   true,
    singleDate:  true,
    singleMonth: true,
    showTopbar:  false,
    selectForward: true,
    hoveringTooltip: false,
    stickyMonths: true,
    getValue: function () {
      if ($check_in.val() && $check_out.val())
        return $check_in.val() + ' ' + $check_out.val();
      else
        return '';
    },
    setValue:    function (s, s1, s2) {
      $check_in.val(s1);
      $check_out.val(s2);
      let $this = $(this);
      // Base implementation
      if (!$this.attr('readonly') && !$this.is(':disabled') && s != $this.val()) {
        $this.val(s);
      }
    },
    beforeShowDay: function (t) {
      let style = t.getDay() === 0 ? 'weekend' : '';
      return [true, style, '', true];
    }
  };

  // add datepickers
  $quote_form.find('.is-date').each(function () {
    $(this).dateRangePicker(date_range_picker_options).on('datepicker-open', function() {
      var offset_left = $is_date.offset().left;
      $('.date-picker-wrapper').css('left', offset_left);
      $('.date-picker-wrapper').css('display: flex');
    }).on('datepicker-opened', function(ev, picker) {
      $(this).prop('readonly', true);
    }).on('datepicker-first-date-selected', function (ev, picker) {
      $(this).val(dayjs(picker.time).format(date_format));
    }).on('datepicker-open', function () {
        $('.date-picker-wrapper').css({
          left: ($(this).offset().left) - 5,
          width: 'auto'
        });
        setTimeout(function(){ $('.real-today').focus(); }, 200);
      });
  });

  // hotels multiple selector
  $quote_form.find('.chosen-select').chosen();

  // prevent screen blinking bug
  // due to duplicated label triggering chosen twice
  // via unbinding events from label
  $('.hotel-selector label').unbind('click');

  // loads prefixes into phone field
  $quoteFormPhone.intlTelInput();
  $quoteFormPhoneManual.intlTelInput();

  if ($quoteFormPhone.data('ame-prefix')) {
    $quoteFormPhone.intlTelInput('setCountry', 'us');
  }

  if ($quoteFormPhoneManual.data('ame-prefix')) {
    $quoteFormPhoneManual.intlTelInput('setCountry', 'us');
  }

  if (IB.currentDevice === 'mobile') {
    $quote_form.find('.fz-collapsable').addClass('fz-collapsed');
    $quote_form.find('.fz-collapse-trigger').addClass('fz-collapsed');

    $quote_form.find('.fz-collapse-trigger').on('click', function () {
      $(this).siblings('.fz-collapsable').toggleClass('fz-collapsed');
      $(this).toggleClass('fz-collapsed');
    });
  }


  $hotel_selector.find('[data-mice-form-hotels-selector]').on('change', function (e) {
    $selection_box.find('.selection-item').remove();
    let v = $(this).val();

    if (v === null) return false;
    let $not_this = $('[data-mice-form-hotels-selector]').not(this);
    let not_this_val = $not_this.val();

    if (_isEqual(v, not_this_val)) return false;

    $not_this.val(v).change().trigger('chosen:updated');

    $.each(v, function (indexInArray, valueOfElement) {
      let data_el = _filter(fastbooking_data.hotels[1], function (p) {
        return 'h' + valueOfElement === p.id;
      });
      let $template = $('<div class="selection-item"><p class="h6">' + data_el[0].title + '</p><div class="stars"><span class="rating-stars r' + data_el[0].data.hotel_category_number + '"></span></div></div>');
      $template.insertAfter($selection_box.find('.selection-title'));
    });
  });

  $hotel_selector.find('[data-mice-form-specialty-selector]').on('change', function (e) {
    let $ul = $selection_box.find('#specialties').find('ul');
    let v = $(this).val();
    let texts = [];
    $.each($("option:selected", this), function(){
      texts.push($(this).text());
    });

    let $not_this = $('[data-mice-form-specialty-selector]').not(this);
    let not_this_val = $not_this.val();

    if (_isEqual(v, not_this_val)) return false;

    $not_this.val(v).change().trigger('chosen:updated');

    $ul.find('li').remove();

    if (v === null) {
      $ul.append($('<li>-</li>'));
    } else {
      $.each(texts,function(i,text){
        let $template = $('<li>' + text + '</li>');
        $ul.append($template);
      })
    }
  });

  $hotel_selector.find('[data-mice-form-budget-selector]').on('change', function (e) {
    let $ul = $selection_box.find('#budget').find('ul');
    let $this = $(this);
    let v = $this.val();
    let $not_this = $('[data-mice-form-budget-selector]').not(this);
    let not_this_val = $not_this.val();

    if (_isEqual(v, not_this_val)) return false;

    $not_this.val(v).change().trigger('chosen:updated');

    $ul.find('li').remove();

    if (v === null) {
      $ul.append($('<li>-</li>'));
    } else {
      $.each(v, function (indexInArray, valueOfElement) {
        let $template = $('<li>' + $this.find('option[value="' + valueOfElement + '"]').text() + '</li>');

        $ul.append($template);
      });
    }
  });


  // enable/disable dependant inputs
  $('[data-toggle-input]').on('change', function () {
    let el = $(this);
    let input = $quote_form.find(el.data('toggle-input'));

    // If checkbox
    if (el.is('input:checkbox')) {
      if (el.is(':checked')) {
        enableInput(input);
      } else {
        disableInput(input);
      }
    } else if (el.is('select')) {
      if (typeof el.find('option:selected').attr('data-toggle-input-trigger') !== 'undefined') {
        enableInput(input);
      } else {
        disableInput(input);
      }
    }
  });

  let enableInput = function (input) {
    input.removeAttr('disabled');
    input.closest('.fz-field').removeClass('disabled');
  };
  let disableInput = function (input) {
    input.attr('disabled', 'disabled');
    input.closest('.fz-field').addClass('disabled');
  };


  // events logic

  let updateAddEvent = function () {
    if ($quote_form.find('.event-wrapper').length >= max_events) {
      $quote_form.find('.event-button').addClass('disabled');
    } else {
      $quote_form.find('.event-button').removeClass('disabled');
    }
  };

  let max_events = 3;
  let events_wrapper_template = $quote_form.find('.event-wrapper').clone().addClass('removable');
  let template_id = 1;

  $quote_form.on('click', '.event-button:not(.disabled)', function () {
    let $actual_wrapper = $quote_form.find('.event-wrapper');

    if ($actual_wrapper.length === max_events) return;

    $actual_wrapper.last().after(events_wrapper_template.clone());

    let $added_events_wrapper = $quote_form.find('.event-wrapper').last();

    $added_events_wrapper.find('input, textarea').each(function () {
      let $this = $(this);
      let id = $this.attr('id');
      $this.attr('id', id + '_' + template_id);
    });

    $added_events_wrapper.find('label').each(function () {
      let $this = $(this);
      let for_val = $this.attr('for');
      $this.attr('for', for_val + '_' + template_id);
    });

    template_id++;

    $added_events_wrapper.find('.is-date').each(function () {
      $(this).dateRangePicker(date_range_picker_options);
    });

    updateAddEvent();
  }).on('click', '.event-button-remove', function () {
    $(this).closest('.event-wrapper').remove();
    updateAddEvent();
  });


  $(document).on('click', '.quote-form-menu a', function (e) {
    e.preventDefault();
    let $this = $(this);
    let hash = this.hash;


    $('.quote-form-menu').find('li.current').removeClass('current');
    $this.parent().addClass('current');


    if (hash === '#quote-form-file') {
      $(hash).removeClass('hidden');
      $('#quote-form-manual-fill').addClass('hidden');
    } else {
      $(hash).removeClass('hidden');
      $('#quote-form-file').addClass('hidden');
    }
  });


  let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  let event = isIE11 ? 'change' : 'input';

  $('[data-people-number-js]').on(event, function () {
    $('[data-people-number-js]').not(this).val($(this).val());
    $('#people_number_show').text($(this).val());
  });
});
